import { Alert, SecondaryButton } from '@designsforhealth/dfh-react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styled, { css } from 'styled-components'

export const OuterContainer = styled.div<{ $dragActive: boolean }>`
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  padding: 10px;
  margin-bottom: 10px;
  ${({ $dragActive }) =>
    // disable pointer events on children while drag active
    $dragActive &&
    css`
      * {
        pointer-events: none;
      }
    `};
`

export const HiddenInput = styled.input`
  display: none;
`

export const InnerContainer = styled.div<{ $dragActive: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (min-width: 600px) {
    flex-direction: row;
    height: 280px;
  }
  border-radius: 4px;
  border-style: dashed;
  border-color: ${({ theme }) => theme.colors.coolGray.cool500};
  background-color: ${({ theme }) => theme.colors.grayscale.white};
  ${({ $dragActive }) =>
    $dragActive &&
    css`
      background-color: ${({ theme }) => theme.colors.coolGray.cool150};
    `};
`

export const Actions = styled.div<{ $isPreviewVisible: boolean }>`
  width: 100%;
  height: 100%;
  border-color: ${({ theme }) => theme.colors.coolGray.cool500};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.coolGray.cool500};
  padding: 10px;

  ${({ $isPreviewVisible }) =>
    $isPreviewVisible &&
    css`
      border-top-style: dashed;

      @media (min-width: 600px) {
        width: 40%;
        border-top-style: none;
        border-left-style: dashed;
      }
    `};
`

export const ImageIcon = styled(FontAwesomeIcon)`
  margin-right: 4px;
`

export const DragText = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  text-align: center;
`

export const FileInformationText = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  padding-top: 5px;
  text-align: center;
`

export const OrText = styled.div`
  font-family: ${({ theme }) => theme.fontFamilies.gothamCondensed};
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 6px;
`

export const Button = styled(SecondaryButton)<{ $dragActive: boolean }>`
  ${({ $dragActive }) =>
    $dragActive &&
    css`
      background-color: ${({ theme }) => theme.colors.coolGray.cool150};
    `};
`

export const RemoveButton = styled(Button)`
  color: ${({ theme }) => theme.colors.brand.orange};
  border-color: ${({ theme }) => theme.colors.brand.orange};
  &:hover {
    color: ${({ theme }) => theme.colors.component.PrimaryButton.default.text};
    background-color: ${({ theme }) => theme.colors.brand.orange};
  }
`

export const ImagePreviewContainer = styled.div`
  width: 100%;
  height: 100%;
  @media (min-width: 600px) {
    width: 60%;
  }
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const ImagePreview = styled.img`
  max-width: 100%;
  max-height: 100%;
`

export const StyledAlert = styled(Alert)`
  padding-top: 10px;
`
